import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import Carousel from 'react-material-ui-carousel';
import { Box, CircularProgress, Chip, Card, CardContent, CardMedia, Typography, Tabs, Tab, Button, Paper } from '@material-ui/core';
// import { Pagination, PaginationItem } from '@material-ui/lab'
// import { getPostsBySearch } from '../../actions/posts';
// import { useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import useStyles from './styles';
import Project from '../../Projects/Project/Project';
import { store } from '../../../index';
import { getProjectsBySearch, getProjects } from '../../../actions/projects';
import ButtonBase from '@material-ui/core/ButtonBase';
import { useDispatch } from 'react-redux';
import useCommonStyles from '../../CommonStyle/commonStyle';



const ProjectRecommend = () => {

    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const [currentId, setCurrentId] = useState(null);
    type RootState = ReturnType<typeof store.getState>;
    const dispatch = useDispatch();
    const history = useHistory();


    const search = '';
    useEffect(() => {
        dispatch(getProjects(1));
        console.log("getProjects called");

    }, [dispatch]);
    //dispatch(getProjectsBySearch({ search, tags: [].join(',') }, 1));


    const { projects, isLoading } = useSelector((state: RootState) => state.projects);
    const project1 = projects[0];
    const project2 = projects[1];
    console.log(project1)



    return (
        isLoading ? <CircularProgress /> : (
            <>
                <Card className={classes.card}>
                    <ButtonBase onClick={() => history.push(`/projects/${project1._id}`)}>
                        <CardMedia className={classes.media} image={project1.imageUrl || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} title={project1.title} />
                        <CardContent>
                            <Typography variant="h6">{project1.title}</Typography>
                            {/* <div className={classes.details}> */}
                            <div>
                                <Typography variant="body2" color="textSecondary" component="h2">{project1.tags.map((tag, index) => <Chip key={index} label={tag} className={classes.chip} />)}</Typography>
                            </div>
                        </CardContent>
                    </ButtonBase>
                </Card>
                <br />
                <Card className={classes.card}>
                    <ButtonBase onClick={() => history.push(`/projects/${project2._id}`)}>
                        <CardMedia className={classes.media} image={project2.imageUrl || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} title={project2.title} />
                        <CardContent>
                            <Typography variant="h6">{project2.title}</Typography>
                            {/* <div className={classes.details}> */}
                            <div>
                                <Typography variant="body2" color="textSecondary" component="h2">{project2.tags.map((tag, index) => <Chip key={index} label={tag} className={classes.chip} />)}</Typography>
                            </div>
                        </CardContent>
                    </ButtonBase>
                </Card>
            </>)
    );
};

export default ProjectRecommend;
